module.exports = __webpack_public_path__ + "img/metro_disabled2.6d10513d.svg";